import { render, staticRenderFns } from "./AboutSections.vue?vue&type=template&id=6c67d6f4&scoped=true&"
import script from "./AboutSections.vue?vue&type=script&lang=ts&"
export * from "./AboutSections.vue?vue&type=script&lang=ts&"
import style0 from "./AboutSections.vue?vue&type=style&index=0&id=6c67d6f4&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c67d6f4",
  null
  
)

export default component.exports